var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{attrs:{"id":"app"}},[_c('Header',{attrs:{"selectedItem":_vm.selected,"isMobile":_vm.isMobile,"isTablet":_vm.isTablet},on:{"on-select":value => _vm.selected = value}}),_c('Content',{attrs:{"selectedItem":_vm.selected,"isMobile":_vm.isMobile,"isTablet":_vm.isTablet}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }